import React from 'react';
import { Navigate, Outlet } from 'react-router';
import { Routes } from './Router';
import useStore from '../hooks/context/useStore';

export default function StoreLoadedGuard() {
  const { storeId } = useStore();

  return storeId ? <Outlet /> : <Navigate to={`/${Routes.NewOrder.Root}`} />;
}
